import Vue from 'vue'
import App from './App.vue'
import router from './_router'
import store from './store'
import vuetify from './plugins/vuetify'

import './registerServiceWorker'

import '@/assets/fa/css/all.min.css'

if (process.env.NODE_ENV === 'development') {
    require('./tailwind.output.local.css')
} else {
    require('./tailwind.output.css')
}

import './_plugins/vbit-api'

import { i18n } from '@/plugins/i18n'
import * as Sentry from '@sentry/vue'
import { Integrations } from '@sentry/tracing'

import axios from 'axios'
import Component from 'vue-class-component'

import VueVirtualScroller from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
Vue.use(VueVirtualScroller)

import InfiniteLoading from 'vue-infinite-loading'

import VueLodash from 'vue-lodash'
import lodash from 'lodash'

import UpdateMixin from '@/_mixins/update'
import GeneralMixin from '@/_mixins/general'
import LodashMixin from '@/_mixins/lodash'
import MomentMixin from '@/_mixins/moment'
import I18NMixin from '@/_mixins/i18n'

import AttachmentMixin from '@/_mixins/attachment'
import { accessClient, courseClient, projectClient } from './apolloClient'
import VueApollo, { ApolloProvider } from 'vue-apollo'

Component.registerHooks(['beforeRouteEnter', 'beforeRouteLeave', 'beforeRouteUpdate'])

Vue.use(InfiniteLoading, {
    /* options */
})
Vue.use(VueLodash, { name: 'custom', lodash: lodash })
Vue.use(VueApollo)
Vue.config.productionTip = false
Vue.prototype.$http = axios

Vue.mixin(UpdateMixin)
Vue.mixin(GeneralMixin)
Vue.mixin(AttachmentMixin)
Vue.mixin(LodashMixin)
Vue.mixin(MomentMixin)
Vue.mixin(I18NMixin)

import AppMixins from '@/_mixins/app'
Vue.mixin(AppMixins)

import ValidatorMixin from '@/_mixins/validator'
Vue.mixin(ValidatorMixin)

Vue.filter('highlight', function (value, query, isOn = true) {
    if (isOn && query && query.length > 0 && value && value.length > 0) {
        let escapedQuery = query.replace(/[-[\]/{}()*+?.\\^$|]/g, '\\$&')

        let qwords = escapedQuery
            .split(' ')
            .sort((a, b) => b.length - a.length)
            .join('|')

        return value.replace(
            new RegExp(qwords, 'ig'),
            (match) => "<span class='highlight-search'>" + match + '</span>'
        )
    } else {
        return value
    }
})

if (process.env.NODE_ENV === 'production') {
    Sentry.init({
        Vue,
        dsn: 'https://f6891423b304425fb2127d41f537113b@o526086.ingest.sentry.io/5975813',
        integrations: [
            new Integrations.BrowserTracing({
                routingInstrumentation: Sentry.vueRouterInstrumentation(router),
                tracingOrigins: ['localhost', 'my-site-url.com', /^\//],
            }),
        ],
        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 1.0,
    })
}

new Vue({
    router,
    store,
    i18n,
    vuetify,
    apolloProvider: new ApolloProvider({
        defaultClient: courseClient,
        clients: {
            access: accessClient,
            default: courseClient,
            project: projectClient,
        },
    }),
    render: (h) => h(App),
}).$mount('#app')
